// ─── Branding (env-driven) ─────────────────────────────────────────────────
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'ERP AI Analytics';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

// ─── Backend API ───────────────────────────────────────────────────────────
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';
/** Optional override; backend uses AI_DEFAULT_PROVIDER from server env when blank. */
export const AI_PROVIDER = import.meta.env.VITE_AI_PROVIDER || '';

// ─── File upload limits ────────────────────────────────────────────────────
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

// ─── UX defaults ───────────────────────────────────────────────────────────
export const QUICK_QUERY_CHIPS = [
  'What are the top performing groups?',
  'Who is the strongest performer?',
  'What are the revenue trends?',
  'Which categories are growing?',
  'Any anomalies in the data?',
];

export const BATCH_INSERT_SIZE = 500;

// ─── Configurable Thresholds ──────────────────────────────────────────────
export const THRESHOLDS = {
  /** Active rate below this percentage triggers an alert in AI insights */
  ACTIVE_RATE_ALERT_PCT: 70,
  /** Top-2 groups exceeding this percentage flags concentration risk */
  CONCENTRATION_RISK_PCT: 70,
  /** Restock quantity multiplier (e.g. 1.2 = 20% buffer) */
  RESTOCK_BUFFER_MULTIPLIER: 1.2,
  /** Minimum template match score (0-1) to consider a detection valid */
  TEMPLATE_MATCH_MIN: 0.5,
  /** Template match score (0-1) at or above which auto-accept without review */
  TEMPLATE_MATCH_AUTO_ACCEPT: 0.8,
  /** Stats cache time-to-live in milliseconds */
  STATS_CACHE_TTL_MS: 60_000,
  /** Database request timeout in milliseconds */
  DB_TIMEOUT_MS: 30_000,
  /** AI request timeout in milliseconds (5 minutes) */
  AI_REQUEST_TIMEOUT_MS: 300_000,
  /** AI model temperature (0-1, lower = more deterministic) */
  AI_TEMPERATURE: 0.3,
  /** AI max response tokens */
  AI_MAX_TOKENS: 2048,
} as const;

// ─── Locale & Currency (env-driven) ────────────────────────────────────────
export const LOCALE_CONFIG = {
  /** BCP 47 locale tag for number/currency formatting */
  LOCALE: import.meta.env.VITE_LOCALE || 'en-US',
  /** ISO 4217 currency code */
  CURRENCY_CODE: import.meta.env.VITE_CURRENCY_CODE || 'USD',
  /** Show currency code as suffix ("164,865 USD") instead of Intl symbol ("$164,865") */
  CURRENCY_SUFFIX: (import.meta.env.VITE_CURRENCY_SUFFIX || 'false').toLowerCase() === 'true',
} as const;
